import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons";
import React from "react";

const AdnStatus = ({ deleted, inactiveText, activeText }) => {
  return (
    <div>
      {deleted == true ? (
        <>
          <CloseCircleOutlined style={{ color: "red" }} />
          {inactiveText ? inactiveText : " Inactive"}
        </>
      ) : (
        <>
          <CheckCircleOutlined style={{ color: "green" }} />
          {activeText ? activeText : " Active"}
        </>
      )}
    </div>
  );
};
export default AdnStatus;
